import { Modal, useMemo} from 'external/react'

import useAuth from 'context/auth-context/hook'

import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import ResetPasswordForm from './ResetPasswordForm'
import FormLayout from './FormLayout'

export default function PublicLayoutModal() {

	const { modalsOpen, handleClose, modals} = useAuth()

	const Form = useMemo(() => {
		if (modals.login.open) return LoginForm	
		if (modals.register.open) return RegisterForm
		if (modals.reset.open) return  ResetPasswordForm
		return undefined
	}, [modals])

	return (
		<Modal show={modalsOpen} onHide={handleClose} size='xl' centered contentClassName='modal__height'>
			<Modal.Header closeButton style={{ borderBottom: 'none' }}></Modal.Header>
			<Modal.Body className='d-flex'>
				<FormLayout>
					{Form && <Form />}
				</FormLayout>
			</Modal.Body>
		</Modal>
	)
}